import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  serviceModalStepper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  stepper: {
    position: 'relative',
    padding: 0,
    marginBottom: 20,
  },
  step: {
    flex: '1 1',
  },
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
  },
  stepLabel: {
    flexDirection: 'column',
    zIndex: 100,
  },
  stepIconContainer: {
    paddingRight: 0,
    cursor: 'pointer',
    zIndex: 100,
  },
  stepLabelText: {
    fontSize: 10,
    textAlign: 'center',
    marginTop: 5,
  },
  stepConnector: {
    position: 'absolute',
    left: '50%',
    top: 12,
    width: '75%',
    height: 1,
    backgroundColor: 'grey',
    transform: 'translate(-50%, 0)',
  },
  stepContent: {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    padding: '2px 0',
    overflow: 'hidden',

    '& .ScrollView': {
      flex: '1 1',
      maxHeight: 500,
      overflow: 'hidden auto',
      padding: 5,
    },

    '& .ButtonsBox': {
      height: 35,
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 20,

      '& .MuiButton-root': {
        textTransform: 'capitalize',
      },

      '& .BackButton': {
        marginRight: 20,
      },

      '& .Hidden': {
        visibility: 'hidden',
      },
    },

    '& h1': {
      fontWeight: 700,
      textAlign: 'center',
      textTransform: 'capitalize',
    },

    '& .FlexBox': {
      position: 'relative',
      width: '100%',
      marginTop: 20,

      '&:first-child': {
        marginTop: 0,
      },

      '&.NoMargin': {
        marginTop: 0,
      },

      '&.Vertical .InfoItem_Label': {
        width: 'auto',
        marginRight: 0,
      },
    },

    '& .InfoItem_Label': {
      width: 150,
      fontWeight: 600,
      textTransform: 'capitalize',
      marginRight: 10,
    },

    '& .InfoItem_Value': {
      flex: 1,
    },

    '& input': {
      padding: '10px 15px',
    },

    '& hr': {
      width: '100%',
    },

    '& .SaveButtonBox': {
      display: 'flex',
      justifyContent: 'center',
      padding: '20px 0',

      '& button': {
        width: 120,
        textTransform: 'none',
      },
    },
  },
});

export default useStyles;
